import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveDirective as _resolveDirective, unref as _unref, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-580d2c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paper-main" }
const _hoisted_2 = { class: "title-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://cdn.xesvip.cn/miniProgram/wechat/image/paper/single-paper.png" })
], -1))
const _hoisted_4 = { class: "paper-info" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "tag-list" }
const _hoisted_7 = { class: "paper-bottom" }
const _hoisted_8 = { class: "see" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dian" }, "·", -1))
const _hoisted_10 = { class: "see" }
const _hoisted_11 = { class: "sjb-paper" }
const _hoisted_12 = { class: "sj-title" }
const _hoisted_13 = {
  class: "sjb-main-svg",
  id: "sjb-main-svg"
}
const _hoisted_14 = {
  class: "answer",
  id: "renderSVGAnswer"
}
const _hoisted_15 = {
  class: "analysis",
  id: "renderSVGAnalysis"
}
const _hoisted_16 = {
  class: "sjb-main",
  id: "sjb-main"
}
const _hoisted_17 = {
  class: "title",
  id: "renderLatexTitle"
}
const _hoisted_18 = {
  class: "answer",
  id: "renderLatexAnswer"
}
const _hoisted_19 = {
  class: "analysis",
  id: "renderLatexAnalysis"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "down-icon" }, null, -1))

import {
  reactive,
  toRefs,
  nextTick,
  watchEffect,
  ref,
  onMounted,
  computed,
  onUnmounted,
} from "vue";
import axios from 'axios';
import tabList from "../base-components/tabList.vue";
import Dialog from "@/components/singlePaper/Dialog.vue";
import { useRouter, useRoute } from "vue-router";
import LoadWrong from "@/components/pub/LoadWrong.vue";
import lego, { exec } from "@/lego";
import {
  getSinglePaperDetail,
  singlePaperDownload,
  getPdfOssAddress,
  paperDownloadExchange,
  paperUploadReport,
} from "@/api/singlePaper";
import getTalInfo from "@/api/getTalInfo";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import BuySinglePaper from "@/components/buyVip/BuySinglePaper.vue";
import { doSourceUrl } from '@/utils/utils';
import { numberToChinese } from '@/utils/utils';
import {
  pvPcpaperdetailBlankBlank, //PC试卷详情页浏览
  showPcpaperdetailEndtryBlank, //曝光试看结束引导模块
  clickPcpaperdetailEndtryPicbutton, //点击试看结束引导图片
  showPcpaperdetailBlankDownload, //试卷宝详情页下载/详解版/答案版曝光
  clickPcpaperdetailBlankDownload, //试卷宝详情页下载/详解版/答案版点击
} from "@/trace/xesTackSingleDetail";

export default /*#__PURE__*/_defineComponent({
  __name: 'paperDetail',
  props: {
  // 试卷列表
  paper_id: {
    type: String,
    default: () => "",
  },
  isReachBottom: {
    type: Boolean,
    defalut: () => false,
  },
  clientHeight: {
    type: Number,
    default: () => 0,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();

const loadWrong = ref(false)

const getToken = () => {
  const { token } = JSON.parse(
    localStorage.getItem("clientCommonMessage") || "{}"
  );
  if (token) {
    return true;
  } else {
    return false;
  }
};

let paper_id = props.paper_id || "";
const defaultTab = ref(1);
const buyVipTitle = ref("");
const tabListData = [
  {
    title: "纯试题版",
    value: 1,
  },
  {
    title: "详解版",
    value: 2,
  },
  {
    title: "答案版",
    value: 3,
  },
];
const DialogMainTitle = ref("");
const DialogSubTitle = ref("");

let router = useRouter();
const route = useRoute();

const isLoading = ref(true);

const isCreatePdf = ref(false);

const subject = ref(0)

// url参数解析
const { from = "", entrance = "空" } = router.currentRoute.value.query;
let questionDataSVG = ref([]);
let questionData = ref([]);
let questionArr = computed(() => {
  return questionData.value.filter((item) => [4, 5].includes(item.contentType));
});
let singlePayload = ref(null);
// 购买金额
const buyInfo = ref(null);
// 是否有试卷权限
const isAuth = ref(null);
// 是否为vip
const isVip = ref(null);
let checked = ref([1]);
const pdfOss = ref("");
// 剩余次数
const surplusCnt = ref(null);
// 10次轮循
let count = 1;
// html 元素
let htmlCode = "";
// pdfname
const pdfName = ref(null);

// 权益次数
const canDownloadCount = ref(null);
// 打开扣减弹窗
const showDownloadDialog = ref(false);
// 附加题 解答题
const spceilQuestionTypeIds = ["8", "9"];
const file_id = ref(null);
const title = ref(null);

const paperInfo = ref({});
const tagsInfo = ref(null);
const paperSee = ref(null);
const questionCnt = ref(null);

const isShowTitle = ref(null);
const isShowAnswer = ref(null);
const isShowAnalysis = ref(null);
const showBuyPaperDia = ref(false);
const downloadBtnText = ref('下载')
const checkCountDown = ref(0);
// latex是否渲染完毕
const lataxFinish = ref(false);
// 是否拿到试卷数据
const isGetData = ref(false);
const isOpenClock = () => {
  store.dispatch("openVipDialog", {
    position: "试看结束",
    entrance: "试卷详情页",
  });
  store.commit("setPreBrowseInfo", paperInfo.value);

  clickPcpaperdetailEndtryPicbutton({
    paper_id: paper_id,
    paper_name: title.value || "",
    visit_type: from ? "站群直接访问" : "试卷宝首页跳转",
  });
};
const handleShowBuyPaper = () => {
  showBuyPaperDia.value = true;
  document.body.classList.add("modal-open");
};
const download = async () => {
  buyVipTitle.value = "下载试卷";
  if(isLoading.value === true || loadWrong.value === true || isCreatePdf.value) return
  if (!getToken()) {
    store.dispatch("openLogin");
    return;
  }
  if (isAuth.value !== 0) {
    checkHtmlCode();
    return;
  }
  if (isVip.value && !surplusCnt.value) {
    ElMessage("暂无下载权限");
    return;
  }
  if (isVip.value && surplusCnt.value > 0) {
    showDownloadDialog.value = true;
    return;
  }
  if (isVip.value && surplusCnt.value === -1) {
    checkHtmlCode();
    return;
  }
  if (!isVip.value) {
    ElMessage("暂无下载权限");
    return;
  }

  // console.log("download....");
};

// 渲染试题
const renderQSLatex = (queData, que_idx, idx) => {
  const spceilDiv = spceilQuestionTypeIds.includes(queData.logicQuesTypeId)
    ? '<div style="height:100px"></div>'
    : "";
  return `${(window as any).TalqsTemplate.render(queData, {
    analyzeVersion: 0,
    hideSource: true,
    hideDifficulty: true,
    queIndex: que_idx + 1,
  })}${spceilDiv}`;
};

// 渲染解析
const renderAnalysisLatex = (queData, idx) => {
  return `<div style="border:1px solid #d6d6d6;padding:10px;margin-top:10px;background-color: #fafff5;"><div style="font-weight:bold">题目${
    idx + 1
  }</div>${(
    window as any
  ).TalqsTemplate.renderPartialComponent(
            'questionAnalyze',
            queData,
            {
              hideDifficulty: true,
              hideSource: true,
              hideCamera: true,
              analyzeVersion: 2
            }
          )}</div>`;
}

// 渲染答案
const renderAnswerLatex = (queData, idx) => {
  return `<div style="border:1px solid #d6d6d6;padding:10px;margin-top:10px;background-color: #fafff5;"><div style="font-weight:bold">题目${
    idx + 1
  }</div>${(window as any).TalqsTemplate.renderPartialComponent(
    "questionAnswer",
    queData
  )}</div>`;
};

// ------------------------------------------------分隔符------------------------------------------------

// 全部渲染
const renderAllSVG = () => {
  isShowTitle.value = true;
  isShowAnswer.value = false;
  isShowAnalysis.value = false;
  // 渲染题目
  let rendexIndex = 0;
  let titleHtml = "";
  let answerHtml = "";
  let analysisHtml = "";
  let firstTitleIndex = 0;
  let titleNum = '';
  for (let i = 0; i < questionDataSVG.value.length; i++) {
    if ([4, 5].includes(questionDataSVG.value[i].contentType)) {
      titleHtml += renderQSLatex(
        questionDataSVG.value[i].question,
        rendexIndex,
        i
      );
      answerHtml += renderAnswerLatex(
        questionDataSVG.value[i].question,
        rendexIndex
      );
      analysisHtml += renderAnalysisLatex(
        questionDataSVG.value[i].question,
        rendexIndex
      );
      rendexIndex++;
    } else {
      let titleContent = questionDataSVG.value[i].content
      if (questionDataSVG.value[i].contentType === 1) {
          firstTitleIndex++;
          titleNum = numberToChinese(firstTitleIndex);
          titleContent = `${titleNum}、${questionDataSVG.value[i].content}`
      }
      titleHtml += `<div style="
                font-family: PingFang SC;
                font-size: 18px;
                font-weight: bold;
                line-height: 20px;
                letter-spacing: 0px;
                color: #0a131e;
              ">${titleContent}</div>`;
    }
  }
  const renderSVGTitle = document.getElementById("renderSVGTitle");
  const renderSVGAnswer = document.getElementById("renderSVGAnswer");
  const renderSVGAnalysis = document.getElementById("renderSVGAnalysis");
  renderSVGTitle.innerHTML = titleHtml;
  renderSVGAnswer.innerHTML = answerHtml;
  renderSVGAnalysis.innerHTML = analysisHtml;
  nextTick(() => {
    /*eslint-disable*/
    (window as any).TalqsTemplate.autoLayout();
    (window as any).MathJax.Hub.Queue([
      "Typeset",
      (window as any).MathJax.Hub,
      document.getElementById("sjb-main-svg"),
    ]);
    (window as any).MathJax.Hub.Queue(() => {
      console.log("试卷渲染完毕");
    });
    /*eslint-disable*/
  });
};

// 全部渲染
const renderAllLatex = () => {
  // 渲染题目
  let rendexIndex = 0;
  let titleHtml = "";
  let answerHtml = "";
  let analysisHtml = "";
  let firstTitleIndex = 0;
  let titleNum = '';
  for (let i = 0; i < questionData.value.length; i++) {
    if ([4, 5].includes(questionData.value[i].contentType)) {
      titleHtml += renderQSLatex(
        questionData.value[i].question,
        rendexIndex,
        i
      );
      answerHtml += renderAnswerLatex(
        questionData.value[i].question,
        rendexIndex
      );
      analysisHtml += renderAnalysisLatex(
        questionData.value[i].question,
        rendexIndex
      );
      rendexIndex++;
    } else {
      let titleContent = questionData.value[i].content
      if (questionData.value[i].contentType === 1) {
          firstTitleIndex++;
          titleNum = numberToChinese(firstTitleIndex);
          titleContent = `${titleNum}、${questionData.value[i].content}`
      }
      titleHtml += `<div style="
                font-family: PingFang SC;
                font-size: 18px;
                font-weight: bold;
                line-height: 20px;
                letter-spacing: 0px;
                color: #0a131e;
              ">${titleContent}</div>`;
    }
  }
  titleHtml = titleHtml.replace(/<p/g, "<div");
  titleHtml = titleHtml.replace(/<\/p>/g, "<\/div>");
  answerHtml = answerHtml.replace(/<p/g, "<div");
  answerHtml = answerHtml.replace(/<\/p>/g, "<\/div>");
  analysisHtml = analysisHtml.replace(/<p/g, "<div");
  analysisHtml = analysisHtml.replace(/<\/p>/g, "<\/div>");
  const renderLatexTitle = document.getElementById("renderLatexTitle");
  const renderLatexAnswer = document.getElementById("renderLatexAnswer");
  const renderLatexAnalysis = document.getElementById("renderLatexAnalysis");
  renderLatexTitle.innerHTML = titleHtml;
  renderLatexAnswer.innerHTML = answerHtml;
  renderLatexAnalysis.innerHTML = analysisHtml;
  nextTick(() => {
    /*eslint-disable*/
    (window as any).TalqsTemplate.autoLayout();
    (window as any).MathJax.Hub.Queue([
      "Typeset",
      (window as any).MathJax.Hub,
      document.getElementById("sjb-main"),
    ]);
    (window as any).MathJax.Hub.Queue(() => {
      console.log("Latex试卷渲染完毕");
      lataxFinish.value = true;
    });
    /*eslint-disable*/
  });
};

/**
 * 虚拟dom 模拟 a 标签下载
 * url：服务端返回url地址 fileName点击下载时生成的文件名
 */
 const downloadFile = async (pdfurl,name) => {
      const response = await axios.get(pdfurl, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/octet-stream' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${name}.pdf`;
      a.click();
    //   window.location.reload();
    }

    // 模拟iframe下载
// const downloadIframe = (pdfurl,name) => {
//   var downloadFrame = document.getElementById('downloadFrame');
//   downloadFrame?.src = pdfurl;
//   downloadFrame.contentWindow.location.reload(true);
// }

// XMLHttpRequest 下载
const downloadXMLHttpRequest = (pdfurl,name) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', pdfurl);
  xhr.responseType = 'blob';
  xhr.send();
  xhr.onreadystatechange = function() {
  if (xhr.readyState === 4 && xhr.status === 200) {
    const blob = xhr.response;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${name}.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);
  }
};
}

const getPdfOssApi = async () => {
  let timer = null;
  try {
    const res = await getPdfOssAddress({
      paper_id: paper_id,
      file_id: file_id.value,
      file_type: 1,
      channel_source:'pc'
    });
    if (res?.data?.status === 1 && count < 10) {
      count++;
      timer = setTimeout(() => {
        getPdfOssApi();
      }, 1000);
    }
    if (res?.data?.status === 2 && res?.data?.file_url === "") {
      const res = await paperDownloadExchange({
        paper_id: paper_id,
        downloadCount: surplusCnt.value,
      });
      count = 0;
      getPdfOssApi();
    }
    if (res?.data?.file_url) {
      pdfOss.value = res?.data?.file_url;
      pdfName.value = res?.data?.file_name;
      paperUploadReport({
        paper_id: paper_id,
        paper_mode: checked.value,
        file_id: file_id.value,
      });
      // downloadJs(pdfOss.value, pdfName.value)
        try {
          // downloadXMLHttpRequest(pdfOss.value, pdfName.value)
          // downloadFile(pdfOss.value, pdfName.value);
          window.open(`${pdfOss.value}&tm=${+ new Date()}`, "_blank");
          // downloadIframe(pdfOss.value, pdfName.value);
        } catch (error) {
          window.open(pdfOss.value, "_blank");
        }
        
        store.dispatch('user/getUserServiceStatus') 
        await getPaperDetail()
        isCreatePdf.value = false;
        
    }
    if (count >= 9) {
      clearTimeout(timer);
      ElMessage("生成失败请重试");
      console.log("生成失败请重试");
      timer = null;
      setTimeout(() => {
        window.location.reload();
      }, 1000);

      return;
    }
  } catch (error) {
    isCreatePdf.value = false;
    console.log(error);
  }
};

const getPdfOss = () => {
  count = 1;
  getPdfOssApi();
};
// 下载接口
const createPdfApi = async () => {
  console.log(htmlCode, "htmlCode");
  try {
    const res = await singlePaperDownload({
      paper_id: paper_id,
      paper_name: title.value,
      paper_content: htmlCode,
      paper_mode: checked.value,
      op_mode: 1,
      template_id: "jy_paper_10001",
    });
    console.log(res, "ressss");
    file_id.value = res?.data.file_id;
    getPdfOss();
  } catch (e) {
    isCreatePdf.value = false;
    console.log(e, "err");
    // ElMessage({
    //   message: e?.message,
    //   type: "warning",
    //   offset: 200,
    // });
  }
};

// 用正则判断字符传中是否存在$$ $$
const checkHtmlCode = () => {
  checkCountDown.value++
  let timerCheckHtml = null
  if(lataxFinish.value){
    getHtmlCode()
    if(timerCheckHtml){
      clearTimeout(timerCheckHtml)
      timerCheckHtml = null
    } 
    return
  }
  timerCheckHtml = setTimeout(()=>{
    if(checkCountDown.value > 4){
      getHtmlCode()
      clearTimeout(timerCheckHtml)
      timerCheckHtml = null
    }
    checkHtmlCode()
  },500)
  
}

const getHtmlCode = () => {
  showDownloadDialog.value = false;
  isCreatePdf.value = true;
  setTimeout(() => {
    let pdfStyle = ''
    //添加覆盖教研云的样式
    let baseStyle = `     
     @media print {
        @page {
          size: portrait; /* 设置页面为纵向 */
        }
      }
      .talqs_analyze_group{
        padding: 10px !important;
      }
      .talqs .talqs_analyze_group .talqs_panel,.talqs .talqs_analyze_single .talqs_panel {
        margin-left: 3.5rem !important;
      }
      .talqs {
        font-size: 18px !important;
        line-height: 1.8em !important;
      }
      .title{
        font-size:18px !important;
        line-height:1.8em !important;
      }
      .answer{
        font-size:18px !important;
        line-height:1.8em !important;
      }
      .analysis{
        font-size:18px !important;
        line-height:1.8em !important;
      }
    `
    let breakStyle = `
      body{
        word-wrap: break-word;
      }
    `
    if(subject.value === 3){
      pdfStyle = `<style>${breakStyle}${baseStyle}</style>`
    }else{
      pdfStyle = `<style>${baseStyle}</style>`
    }
      // 获取body下的前两个元素
      let div1 = document.getElementsByTagName("body")[0].children[0];
      let div2 = document.getElementsByTagName("body")[0].children[1];
      let div2HtmlCode = div2.outerHTML.indexOf("app") > -1 ? "" : div2.outerHTML;
      const element = document.getElementById("sjb-main"); // 获取ID为'your-id'的元素
      const titleHtml = `<div style="font-size: 26px;line-height: 60px;color: #0A131E;text-align: center;padding: 10px 0 20px; font-weight: bold;">${title.value}</div>`;
      htmlCode =
        pdfStyle + div1.outerHTML + div2HtmlCode + titleHtml + element.innerHTML; // 获取该元素的所有HTML代码
      console.log(htmlCode,'htmlCode');
      // 生成pdf
      createPdfApi();
  },3000)
};

// 获取试卷详情--渲染用
const getPaperDetail = async () => {
  if(!paper_id || paper_id.length < 32){
    ElMessage.error('数据错误，请求失败');
    loadWrong.value = true
    return
  }
  try {
    const res = await getSinglePaperDetail({
      paper_id: paper_id,
      is_svg: 1,
      is_view: 0,
    });
    loadWrong.value = false
    questionDataSVG.value = res?.data?.detail?.elementList || [];
    paperInfo.value = res?.data?.detail;
    tagsInfo.value = res?.data?.tags_info;
    paperSee.value = res?.data?.views;
    questionCnt.value = res?.data?.question_cnt;
    isAuth.value = res?.data?.is_auth; //res?.isAuth
    isVip.value = res?.data?.is_paper_vip; // res?.isVip res?.isPaperVip
    surplusCnt.value = res?.data?.surplus_cnt;
    buyInfo.value = res?.data?.buy_info?.alone_buy;
    DialogMainTitle.value = `本月剩余:${surplusCnt.value}次`;
    title.value = res?.data?.detail?.name || "";
    subject.value = res?.data?.detail?.subjectId || 0
    singlePayload.value = {
      mall_id: 1,
      source: 11,
      skus: [
        {
          product_count: 1,
          sku_unionid: buyInfo?.value?.sku_unionid,
          spu_unionid: buyInfo?.value?.spu_unionid,
          supplier_data: {
            code: paper_id,
            name: title.value,
          },
          source_id: '',
          source_url: doSourceUrl(),
        },
      ],
      promotion: null,
    };

    getPaperDetailLatex();
    renderAllSVG();
  } catch (error) {
    loadWrong.value = true
    console.error(error, "err");
  }
};
// 获取试卷详情- 打印用
const getPaperDetailLatex = async () => {
  const res = await getSinglePaperDetail({
    paper_id: paper_id,
    is_svg: 0,
    is_view: 1,
  });
  questionData.value = res?.data?.detail?.elementList;

  isLoading.value = false;
  isGetData.value = true;
  // 切换选项重新生成
  renderAllLatex();
  // changeBoxLatex();
};

// reload
const reload = () => {
  location.reload();
};

// 加锁埋点
const clockTrack = () => {
  showPcpaperdetailEndtryBlank({
    paper_id: paper_id,
    paper_name: title.value || "",
    visit_type: from ? "站群直接访问" : "试卷宝首页跳转",
  });
};

const tabClick = (data) => {
  buyVipTitle.value = data.title;
  clickPcpaperdetailBlankDownload({
    is_login: getToken() ? "是" : "否",
    is_vip: isVip.value ? "是" : "否",
    content: data.title,
  });
  if (!getToken()) {
    store.dispatch("openVipDialog", {
      position: data.title,
      entrance: "试卷详情页",
    });
    return;
  }
  if (isAuth.value || isVip.value) {
    console.log(data, "data");
    defaultTab.value = data.value;
    isShowAnswer.value = data.value === 3 ? true : false;
    isShowAnalysis.value = data.value === 2 ? true : false;
    if (isShowAnswer.value === true) {
      checked.value = [1, 2];
    } else if (isShowAnalysis.value === true) {
      checked.value = [1, 3];
    } else {
      checked.value = [1];
    }
    // getHtmlCode();
    return;
  } else {
    store.dispatch("openVipDialog", {
      position: data.title,
      entrance: "试卷详情页",
    });
  }
  //   if (isVip.value || surplusCnt.value) {
  //       if ((surplusCnt.value > 0 || surplusCnt.value === -1) && isAuth.value === 0) {
  //             defaultTab.value = data.value;
  //             isShowAnswer.value = data.value === 3 ? true : false;
  //             isShowAnalysis.value = data.value === 2 ? true : false;
  //             if (isShowAnswer.value === true) {
  //             checked.value = [1, 2];
  //             } else if (isShowAnalysis.value === true) {
  //             checked.value = [1, 3];
  //             } else {
  //             checked.value = [1];
  //         }
  //         // 打开弹窗
  //         // showDownloadDialog.value = true;
  //         // return;
  //       } else {
  //         // 打开弹窗
  //         data.value !== 1 && handleShowBuyPaper();
  //         return;
  //       }
  //     } else {
  //       data.value !== 1 && handleShowBuyPaper();
  //       return;
  //     }
};
// 购买弹窗关闭的情况下 需要重新刷获取详情的接口 type: 1 没有支付关闭弹窗 2: 支付成功后的关闭弹窗
const handleCloseSinglePaperDia = (type:number) => {
  showBuyPaperDia.value = false;
  document.body.classList.remove("modal-open");
  if (type === 2) {
    window.location.reload();
  }
};

onMounted(async () => {
    await getPaperDetail();
  // 曝光
  pvPcpaperdetailBlankBlank({
    paper_id: paper_id,
    paper_name: title.value || "",
    visit_type: from ? "站群直接访问" : "试卷宝首页跳转",
    entrance
  });
  showPcpaperdetailBlankDownload({
    paper_id: paper_id,
    paper_name: title.value || "",
    visit_type: from ? "站群直接访问" : "试卷宝首页跳转",
    is_login: getToken() ? "是" : "否",
    is_vip: isVip.value ? "是" : "否",
  });
  clockTrack();
  // 加锁埋点

  //   if(login){

  //   }
});
onUnmounted(() => {});

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(tabList, {
        onTabClick: tabClick,
        defaultValue: defaultTab.value,
        data: tabListData
      }, null, 8, ["defaultValue"]),
      (loadWrong.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (loadWrong.value)
              ? (_openBlock(), _createBlock(LoadWrong, {
                  key: 0,
                  onReloadPage: _cache[0] || (_cache[0] = () => getPaperDetail())
                }))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(paperInfo.value?.name), 1),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsInfo.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "tag-item",
                      key: index
                    }, _toDisplayString(item?.tag_name), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(paperSee.value) + "浏览", 1),
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(questionCnt.value) + "题", 1)
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(paperInfo.value?.name), 1),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["title", subject.value === 3 ? 'break' : '']),
                  id: "renderSVGTitle"
                }, null, 2), [
                  [_vShow, isShowTitle.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_14, null, 512), [
                  [_vShow, isShowAnswer.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [
                  [_vShow, isShowAnalysis.value]
                ])
              ])
            ])), [
              [_directive_loading, isLoading.value]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [
                [_vShow, isShowTitle.value]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [
                [_vShow, isShowAnswer.value]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_19, null, 512), [
                [_vShow, isShowAnalysis.value]
              ])
            ])
          ], 64)),
      _createVNode(BuySinglePaper, {
        showBuyPaper: showBuyPaperDia.value,
        title: buyVipTitle.value,
        isVip: isVip.value,
        paperUnitPrice: buyInfo.value?.sale_price_cent,
        paperData: paperInfo.value,
        payload: _unref(singlePayload),
        onOnCloseSinglePaperDia: handleCloseSinglePaperDia
      }, null, 8, ["showBuyPaper", "title", "isVip", "paperUnitPrice", "paperData", "payload"]),
      (showDownloadDialog.value)
        ? (_openBlock(), _createBlock(Dialog, {
            key: 2,
            mainTitle: DialogMainTitle.value,
            subTitle: "(已下载试卷，重复下载不计次数)",
            onCancelHandler: _cache[1] || (_cache[1] = ($event: any) => (showDownloadDialog.value = false)),
            onConfirmHandler: _cache[2] || (_cache[2] = ($event: any) => (checkHtmlCode()))
          }, null, 8, ["mainTitle"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["action-box", !__props.isReachBottom ? 'fixedStyle' : 'clearFixed']),
      style: _normalizeStyle({ bottom: __props.isReachBottom ? '' : '0px' })
    }, [
      _createElementVNode("div", {
        class: "m-btn",
        onClick: download
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(isLoading.value === false && loadWrong.value === false ? 'u-btn' : 'grey')
        }, [
          _hoisted_20,
          _createTextVNode(" " + _toDisplayString(isCreatePdf.value? '生成中...': '下载'), 1)
        ], 2)
      ])
    ], 6)
  ], 64))
}
}

})